import React, { useEffect } from "react";
import MainRouter from "./mainRouter";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import "./Sass/custom.scss";
import { requestInterceptor, checkJwtExp } from "./axiosFxns";

// api BASEURL
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL_API;

// Add a request interceptor
axios.interceptors.request.use(requestInterceptor, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

function App() {
  useEffect(() => {
    checkJwtExp();
  }, []);
  return (
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  );
}

export default App;
